/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// init AOS
$(function() {
  AOS.init({
    duration: 1000,
    once: true
  });
});


/*================ Add to cart ================*/
// $('.js-add-to-cart').click(function(e) {
//   e.preventDefault();
//   var id = Number($(this).data('id'));
//   CartJS.addItem(id, {
//     "success": function() {
//       setTimeout(function() {
//         document.documentElement.dispatchEvent(new CustomEvent('product:added', {
//           bubbles: true,
//           detail: {
//             variant: id,
//             quantity: 1
//           }
//         }));        
//       }, 350);
//     }
//   });
// });


$(document).on("click", '.js-add-to-cart', function (e) {
    e.preventDefault();
    var t = 1;
    var a = $(this).data("id");
    var o = {
        type: "POST",
        url: "/cart/add.js",
        data: { quantity: t, id: a },
        dataType: "json",
        success: function (a) {
            document.documentElement.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { quantity: t } }));
        },
        error: function () {
            alert("sold out, sorry!");
        },
    };
    $.ajax(o);
});
$(document).on("click", '.best-sellers_item [data-action="add-to-cart"]', function (e) {
  e.preventDefault();
  var formElement = $(this).closest('form[action*="/cart/add"]');

  var data = JSON.stringify(formElement.serialize());
  var t = formElement.find('.QuantitySelector__CurrentQuantity').val();
  jQuery.post(window.Shopify.routes.root + 'cart/add.js', formElement.serialize()).then((data)=>{
    document.documentElement.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { quantity: t } }));
  });
  // var o = {
  //     type: "POST",
  //     url: "/cart/add.js",
  //     data: data,
  //     dataType: "json",
  //     success: function (a) {
  //         document.documentElement.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { quantity: t } }));
  //     },
  //     error: function () {
  //         alert("sold out, sorry!");
  //     },
  // };
  // $.ajax(o);
});
$(document).on('click', '.add-to-cart-button', function(e){
  e.preventDefault();
  var t = $(this).closest('.formButtons__wrapper').find('.current_quantity').text()
  var id = $(this).closest('.stickyProductForm').find('select.ec-button-select').find(":selected").val();
  if($("#rechargeAppController:checked").length>0){
    var id= $(this).closest('.stickyProductForm').find('#rc_duplicate_selector').find(":selected").val();
    var frequency = "days";
    var unit_type = "30";
  }
  addItemToCart(id, t,frequency, unit_type)
})

$('.recharge-add-to-cart').click(function(e){
  e.preventDefault()
  if($(this).data('subid')){
    var id = Number($(this).data('subid'));
  }else{
    var id = $(this).closest('#main').find('#rc_duplicate_selector option:first-child').attr('value');
  }
  addItemToCart(id, 1, "days", "30")
});
function addItemToCart(variant_id, qty, frequency, unit_type) {
  data = {
    "id": variant_id,
    "quantity": qty,
    "properties": {
      "shipping_interval_frequency": frequency,
      "shipping_interval_unit_type": unit_type
    }
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      setTimeout(function() {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: variant_id,
            quantity: 1
          }
        }));
      }, 350);
    }
  });
 
}
function reChargeProcessCart() {
	function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
	do {
      		token=get_cookie('cart');
	}
	while(token == undefined);	var myshopify_domain='bramabeans.myshopify.com'
	try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
	checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker;
	console.log(checkout_url)
	window.location.href = checkout_url;
}

function routeCheckout() {
  jQuery.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) { 
      let recharge = false;
      for (item in cart.items) {
        var item_m = cart.items[item].properties;
        if(item_m!="" && item_m!= null ){
        if(!!cart.items[item].properties.shipping_interval_frequency){
          recharge = true;
          break;
        }
        } else {
          window.location.href = "/checkout";
        }
      }

      if (recharge) {
        reChargeProcessCart()
      } else {
        window.location.href = "/checkout"
      }
    }
  })
}


$('.Shop__Nav').click(function() {
  if($('#shop-menu').attr('aria-hidden') == 'true') {
    $('#shop-menu').attr('tabindex','-1')
    $('#shop-menu').attr('aria-hidden','false')
  } else {
    $('#shop-menu').removeAttr('tabindex')
    $('#shop-menu').attr('aria-hidden','true')
  }
})

$('#shop-menu .Drawer__Close').click(function() {
  $('#shop-menu').removeAttr('tabindex')
  $('#shop-menu').attr('aria-hidden','true')
})

 

$(document).on('click', '.Cart_Count, .QuantitySelector__Button, .CartItem__Remove, .rebuy-button', function(){
  setTimeout(function(){  

    jQuery.getJSON('/cart.js', function(cart){
      let recharge = false;
      for ( var i = 0, l = cart.items.length; i < l; i++ ) {
        console.log(cart.items[i].properties)
        var item_m = cart.items[i].properties;
        if(item_m!="" && item_m!= null ){
          if(!!cart.items[i].properties.shipping_interval_frequency){
            recharge = true;
            break;
            console.log(cart.items[i].properties.shipping_interval_frequency)
          }
        }
      }

      console.log(recharge)

      if (recharge) {
        $('.Cart__Checkout').addClass('additional-checkout-actions-disable')
      } else {
        $('.Cart__Checkout').removeClass('additional-checkout-actions-disable')
      }
    });
  }, 1000);
});
// Update add to cart button price when the quantity is changed - Home page
$(document).on('click', '.section-best-sellers .QuantitySelector__Button', function(e){
  var that = $(this);
  setTimeout(function(){  
    var action = $(e.target).attr('data-action');
    var input = $(e.target).parent().find('.QuantitySelector__CurrentQuantity');
    if(action === 'increase-quantity'){
      var newQuantity = input.val()*1 + 1;
    }else{
      if(input.val()*1 >= 1){
      var newQuantity = input.val()*1 - 1;
      }
    }
    input.val(newQuantity);
    console.log(that.closest('form'));
    var addToCart = that.closest('form').find('.ProductForm__AddToCart');
    var priceDom = addToCart.find('.Button__SeparatorDot').next();
    var currency = priceDom.text().slice(0,1);
    var currentPrice = addToCart.attr('data-price');
    var newPrice =currentPrice * newQuantity;
    if(currentPrice !== newPrice){
      priceDom.text(currency + " "+ newPrice.toFixed(2));
    }
  }, 500);
});

// Update add to cart button price when the quantity is changed - Product page

$(document).on('click', '.Product .QuantitySelector__Button', function(e){
  var that = $(this);
  setTimeout(function(){ 
    var quantity = $(e.target).parent().find('.QuantitySelector__CurrentQuantity').val();
    var addToCart = that.closest('form').find('.ProductForm__AddToCart');
    var priceDom = addToCart.find('.Button__SeparatorDot').next();
    var currency = priceDom.text().slice(0,1);
    var currentPrice = addToCart.attr('data-price');
    var newPrice =currentPrice * quantity;
    if(currentPrice !== newPrice){
      priceDom.text(currency + " "+ newPrice.toFixed(2));
    }
  }, 500);
});
// Update add to cart button price when the subscription is changed
$(document).on('click', '#rc_radio_options', function(e){
  var checked = $(this).find('input:checked');
  if(checked){
    var newPrice = checked.next().find('.rc_price').text();
    var addToCart = $(this).closest('form').find('.ProductForm__AddToCart');
    var quantity  = $(this).closest('form').find('.QuantitySelector__CurrentQuantity').val();
    var priceDom = addToCart.find('.Button__SeparatorDot').next();
    var currentAddToCartPrice = parseFloat(priceDom.text().slice(1));
    var currentPrice = parseFloat(newPrice.slice(1));
    
    // update add to cart data-price
    addToCart.attr('data-price', currentPrice)
    var currency = newPrice.slice(0,1);
    newPrice = currentPrice * quantity;
    if(currentAddToCartPrice !== newPrice){
      priceDom.text(currency + " "+ newPrice.toFixed(2));
    }
  }
});

$(document).on('click', '.rebuy-button', function(){
  setTimeout(function(){  
    jQuery.getJSON('/cart.js', function(cart){
      let recharge = false;
      for ( var i = 0, l = cart.items.length; i < l; i++ ) {
        console.log(cart.items[i].properties)
        var item_m = cart.items[i].properties;
        if(item_m!="" && item_m!= null ){
          if(!!cart.items[i].properties.shipping_interval_frequency){
            recharge = true;
            break;
            console.log(cart.items[i].properties.shipping_interval_frequency)
          }
        }
      }

      console.log(recharge)

      if (recharge) {
        $('.Cart__Checkout').addClass('additional-checkout-actions-disable')
      } else {
        $('.Cart__Checkout').removeClass('additional-checkout-actions-disable')
      }
    });
  }, 1000);
});
$('.toggle').click(function() {
  $(this).parent().find('.toggle').css({'background-color': 'white','color': 'black'})
  $(this).parent().find('.toggle').removeClass('optionSelected')
  $(this).css({'background-color': 'black','color': 'white'})
  $(this).addClass('optionSelected')
  $('.swap-image-buttons').children().eq(0).css({'background-color':'black', 'color':'white'})
  $('.swap-image-buttons').children().eq(1).css({'background-color':'white', 'color':'black'})

   let option_val = $(this).text()
   $(`.SizeSwatch__Radio[value="${option_val}"]`).click();
   
   if ($('.single-serve').hasClass('optionSelected')) {
     $('.save-sticker').hide();
     $('.nutrition_image2').show()
     $('.nutrition_image1').hide()
   } else {
     $('.save-sticker').show();
     $('.nutrition_image1').show()
     $('.nutrition_image2').hide()
   }
  
  
})



$('.flavor').click(function() {
  $('.product-dropdown-container .list').toggle();
})

$('.custom-addToCart').click(function(e) {
  e.preventDefault();
  var quant = Number($('.customQuant').val())
  var id = Number($(this).attr('var_id'));
  CartJS.addItem(id, quant, {
    "success": function() {
      setTimeout(function() {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: id,
            quantity: quant
          }
        }));
      }, 350);
    }
  });
});


$('.faq-question').click(function() {
  $(this).find('.faq-up').toggle()
  $(this).find('.faq-down').toggle()
  $(this).next().toggle()
})


$('.swap-image-buttons .Button').click(function() {
  let image_id = Number($(this).data('id'));
  $('.swap-image-buttons .Button').css({'background-color':'white', 'color':'black'})
  $(this).css({'background-color':'black', 'color':'white'})
  
  $('.Product__SlideItem').removeClass('is-selected')
  $('.Product__SlideItem').css('left', '100%')
  $('.Product__SlideItem').addClass('Product__SlideItem--hidden')

  $(`.flickity-slider`).children().eq(image_id).addClass('is-selected')
  $(`.flickity-slider`).children().eq(image_id).removeClass('Product__SlideItem--hidden')
  $(`.flickity-slider`).children().eq(image_id).css('left', '0%')
});


$(".toggle").mouseup(function() {
  setTimeout(function() {
    var new_price = $('form .ProductForm__Variants select option:selected').attr('data-price');
    $('.wholesale-only #rc_price_onetime').text(new_price);
    $('.full-price').text($('#rc_price_onetime').text());
  },100)
});


$(document).on('click', '.single-serve', function(){
  if($(this).closest('.variant-option').next().find('.toggle-container').find('.multi-serve').length >1 ){
       $(this).closest('.variant-option').next().find('.toggle-container').addClass('disable-options')
  }
  $(this).closest('.variant-option').next().find('.eight-pouch').click();
})
$(document).on('click', '.multi-serve', function(){
  $(this).closest('.variant-option').next().find('.toggle-container').removeClass('disable-options')
//   $(this).closest('.variant-option').next().find('.toggle1').click();
})

